import * as React from "react";
import { css } from "@joeybright/compose";

interface ButtonProps {
  children: any;
  color?: string;
  size?: "small" | "medium" | "large";
  variant?: "primary" | "secondary" | "tertiary";
}

const Button: React.FunctionComponent<ButtonProps> = props => {
  const styles = css({
    width: "100%",
    overflowWrap: "anywhere",
    textAlign: "center",
    p: 4,
    background: props.color ? props.color : "blue",
    borderRadius: "4px",
    color: "white",
    "@media (min-width: 933px)": {
      background: props.color ? props.color : "green",
      p: 3
    }
  });

  return (
    <div css={styles} {...props}>
      {props.children}
    </div>
  );
};

export default Button;
